import React from "react";
import { Box } from "@mui/material";
import { DISTANT_HERO } from "../../ProductHeroes";
import { PRODUCT_IMAGES } from "../../ProductDetails";

// Compose the artwork from live hero assets so it never retains an old screenshot.
const StoreArtwork = ({ name, bundle = false }: { name: string; bundle?: boolean }) => (
  <Box sx={{
    position: "relative", width: "100%", aspectRatio: "16 / 9", maxHeight: "350px",
    borderRadius: "10px", mb: 3, overflow: "hidden",
    background: "radial-gradient(ellipse at top, #344048, #1b2228)",
  }}>
    <Box component="img" src={DISTANT_HERO.src}
      alt={bundle ? `ToneSuite - Distant included in ${name}` : name}
      width={DISTANT_HERO.width} height={DISTANT_HERO.height}
      sx={{
        position: "absolute", objectFit: "contain", height: bundle ? "68%" : "100%",
        width: bundle ? "55%" : "86%", left: bundle ? "4%" : "7%", top: bundle ? "9%" : "0%",
        filter: "drop-shadow(0 8px 12px rgba(0,0,0,0.5))",
      }} />
    {bundle && <Box component="img" src={PRODUCT_IMAGES["distant-bass-suite"]}
      alt={`BassSuite - Distant included in ${name}`}
      sx={{
        position: "absolute", objectFit: "contain", height: "78%",
        width: "61%", right: "2%", bottom: "7%",
        filter: "drop-shadow(0 8px 12px rgba(0,0,0,0.5))",
      }} />}
  </Box>
);

export default StoreArtwork;
